module.exports = __webpack_public_path__ + "img/arrow-circle-right.0ba8c46e.svg";